import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity, EntityIdentifier} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {TagAssignmentKind, toTagAssignmentKind} from "./tag-assignment-kind";

export const TagAssignmentCodec = t.intersection([
  t.type({
    id: t.string,
    tagDefinitionId: t.string,
    objectId: t.string,
    objectType: t.string,
    assignmentKind: t.string,
  }),
  t.partial({
    label: t.string,
    colorHex: t.string,
    categories: t.array(t.string),
    createdById: t.string,
    lastModifiedById: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,

    defKey: t.string,
    categoryKeys: t.array(t.string),
  }),
]);

export type TagAssignment = t.TypeOf<typeof TagAssignmentCodec>;

@Exclude()
export class TagAssignmentEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  tagDefinitionId!: string;

  @Expose()
  objectId!: string;

  @Expose()
  objectType!: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toTagAssignmentKind))
  assignmentKind!: TagAssignmentKind;

  @Expose()
  label?: string;

  @Expose()
  colorHex?: string;

  @Expose()
  categories?: string[];

  @Expose()
  doNotUse!: boolean;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  @Expose()
  defKey?: string;

  @Expose()
  categoryKeys?: string[];

  readonly entityType = "TAGASSIGNMENT";

  get displayName(): Readonly<string> {
    return this.label ?? this.id;
  }

  constructor() {
  }

  static from(value: TagAssignment): TagAssignmentEntity {
    return plainToInstance(TagAssignmentEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<TagAssignment> {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSON(TagAssignmentCodec, object);
  }

  asTypeValue(): TagAssignment {
    const object = instanceToPlain(this, {excludeExtraneousValues: true});
    return validateJSONNow(TagAssignmentCodec, object);
  }
}

export const TagAssignmentReplaceRequestCodec = t.intersection([
  t.type({
    tagDefIds: t.array(t.string),
  }),
  t.partial({

  }),
]);

export type TagAssignmentReplaceRequest = t.TypeOf<typeof TagAssignmentReplaceRequestCodec>;

export type TagAssignmentBulkRequest = {
  addTagDefIds: string[];
  removeTagDefIds: string[];
  objects: EntityIdentifier[];
}

export const TagSearchHitCodec = t.intersection([
  t.type({
    objectId: t.string,
    objectType: t.string,
    score: t.number,
  }),
  t.partial({
    objectName: t.string,
  }),
]);

export type TagSearchHit = t.TypeOf<typeof TagSearchHitCodec>;
